module.exports = __webpack_public_path__ + "static/img/right-tip.718381f2.png";